<template>
  <v-layout row justify-center>
    <v-dialog v-model="showNewEditExercise" max-width="700"
      transition="dialog-bottom-transition" @keydown.esc="showNewEditExercise = false">
      <v-card>
        <v-toolbar color="blue-grey lighten-5">
          <v-spacer></v-spacer>
          <v-toolbar-title class="text-xs-center">
            <span v-if="exercise._id">Editar</span>
            <span v-else>Novo</span>
            exercício
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.stop="showNewEditExercise = false">
            <v-icon>fal fa-times</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field label="Nome do exercício" v-model="exercise.name" required></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-select :items="exerciseTypes" item-text="name" item-value="value"
                  label="Tipo" v-model="exercise.type" append-icon="fal fa-chevron-down" required></v-select>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field label="Grupo Muscular" v-model="exercise.muscle" required></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field label="Link do vídeo" v-model="exercise.video_link"></v-text-field>
                <youtube :video-id="videoId(exercise.video_link)" :player-vars="playerConfig"
                  v-if="exercise.video_link" player-width="100%" @ready="ready"></youtube>
              </v-flex>
              <v-flex xs12>
                <v-textarea v-model="exercise.description" label="Descrição"
                  rows="2" auto-grow required ></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.stop="save()" round large depressed color="success"
            :loading="loadingRequest">
            <span v-if="exercise && exercise._id">Editar</span>
            <span v-else>Cadastrar</span>
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import EventBus from '@/event-bus'
import axios from 'axios'

export default {
  data: () => ({
    showNewEditExercise: false,
    loadingRequest: false,
    exercise: {},
    exerciseTypes: [
      { name: 'Musculação', value: 'muscle' },
      { name: 'Aeróbico', value: 'aerobic' }
    ],
    playerConfig: {
      rel: 0, showInfo: 0
    },
    player: null
  }),

  methods: {
    save () {
      this.loadingRequest = true
      let $request
      let path

      if (this.exercise._id) {
        $request = axios.put
        // eslint-disable-next-line
        path = `${API.userExercises}/${this.exercise._id}`
      } else {
        $request = axios.post
        // eslint-disable-next-line
        path = `${API.userExercises}/`
      }

      $request(path, this.exercise).then(response => {
        this.showNewEditExercise = false
        this.loadingRequest = false
        EventBus.$emit('loadExercises')
      }).catch(errors => {
        this.loadingRequest = false
        EventBus.$emit('showSnackbar', {
          message: 'Erro ao criar o exercício',
          color: 'error'
        })
      })
    },

    videoId (url) {
      return this.$youtube.getIdFromURL(url)
    },

    ready (event) {
      this.player = event.target
    },

    checkIfIsClosed () {
      if (this.player) this.player.stopVideo()
    }
  },

  beforeDestroy () {
    EventBus.$off('showNewEditExercise')
    EventBus.$off('exerciseCurrentData')
  },

  mounted () {
    EventBus.$on('showNewEditExercise', data => {
      this.showNewEditExercise = data
      this.exercise = {}
    })

    EventBus.$on('exerciseCurrentData', data => {
      this.exercise = data
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/exercises/AdminNewEditExercise.vue